module.exports = __webpack_public_path__ + "static/img/案例BG.0420c769.png";